import { useQuery } from "@apollo/client/react";
import { GetCouponDocument } from '@drycut/graphql';
import { Redemption } from '@drycut/referral-components';
import { Loader } from '@drycut/ui-components';
import { useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

export function ReferralRedemption(): React.ReactElement {
  useDocumentTitle('DryCut Referral');

  const { code } = useParams() as { code: string };
  const { data, loading } = useQuery(GetCouponDocument, { variables: { code } });

  if (loading) {
    return <Loader />;
  }

  return <Redemption coupon={data?.coupon} />;
}
